<script setup>
import { computed } from 'vue';
import { useToggle } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import CardLayout from 'dashboard/components-next/CardLayout.vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const props = defineProps({
  service: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const emit = defineEmits(['select', 'edit', 'delete']);
const { t } = useI18n();
const [showMenu, toggleMenu] = useToggle();

const details = computed(() =>
  [props.service.price, props.service.duration].filter(Boolean).join(' · ')
);

const menuItems = computed(() => [
  {
    label: t('ARROWS_AI.SERVICES.EDIT'),
    value: 'edit',
    action: 'edit',
    icon: 'i-lucide-pencil-line',
  },
  {
    label: t('ARROWS_AI.SERVICES.DELETE'),
    value: 'delete',
    action: 'delete',
    icon: 'i-lucide-trash',
  },
]);

const handleAction = ({ action }) => {
  toggleMenu(false);
  if (action === 'edit') emit('edit', props.service);
  if (action === 'delete') emit('delete', props.service.id);
};
</script>

<template>
  <CardLayout selectable class="relative">
    <div class="absolute top-7 ltr:left-3 rtl:right-3">
      <Checkbox
        :model-value="selected"
        @update:model-value="emit('select', service.id)"
      />
    </div>
    <div class="flex justify-between w-full gap-2">
      <h3 class="text-base text-n-slate-12 line-clamp-1">
        {{ service.name }}
      </h3>
      <div class="relative">
        <Button
          icon="i-lucide-ellipsis-vertical"
          color="slate"
          size="xs"
          @click="toggleMenu()"
        />
        <DropdownMenu
          v-if="showMenu"
          :menu-items="menuItems"
          class="mt-1 ltr:right-0 top-full"
          @action="handleAction"
        />
      </div>
    </div>
    <p v-if="service.description" class="text-sm text-n-slate-11 line-clamp-2">
      {{ service.description }}
    </p>
    <p v-if="details" class="text-xs text-n-slate-10">
      {{ details }}
    </p>
  </CardLayout>
</template>
